import { Warning } from '@mui/icons-material';
import useConfirmationAlertDialog from './use-confirmation-alert-dialog';

const useUnsavedChangesDialog = () => {
  const openConfirmationAlertDialog = useConfirmationAlertDialog();

  const handleUnsavedChanges = (onConfirm: () => void) => {
    return openConfirmationAlertDialog({
      title: 'Unsaved Changes',
      icon: <Warning />,
      iconColor: 'warning',
      iconBorderColor: 'warningContainer',
      avatarCaption: 'Warning',
      message:
        'You have unsaved changes. Are you sure you want to close without saving?',
      cancelText: 'Cancel',
      confirmationText: 'Close without saving',
      confirmButtonColor: 'warning',
    }).then(confirmed => {
      if (confirmed) {
        onConfirm();
      }
    });
  };

  return handleUnsavedChanges;
};

export default useUnsavedChangesDialog;
